<template>
    <div class="barcode-container">
        <h2>Wine details:</h2>
        <div class="barcode-row">
            <div class="bold">Producer:</div>
            Fombrauge
        </div>
        <div class="barcode-row">
            <div class="bold">Vintage:</div>
            2016
        </div>
        <div class="barcode-row">
            <div class="bold">{{ $t('address15') }}:</div>
            France
        </div>
        <div class="barcode-row">
            <div class="bold">{{ $t('region') }}:</div>
            Bordeaux
        </div>
        <div class="barcode-row">
            <div class="bold">Appellation:</div>
            Saint-Emilion Grand Cru
        </div>
        <div class="barcode-row">
            <div class="bold">Classification:</div>
            Grand Cru Classé Saint-Emilion
        </div>
        <div class="barcode-row">
            <div class="bold">Case size:</div>
            1x0.750l
        </div>

        <h2>Case details:</h2>
        <div class="barcode-row">
            <div class="bold">Case ID:</div>
            396_48_106_001
        </div>
        <div class="barcode-row">
            <div class="bold">Warehouse location:</div>
            JF Bordeaux
        </div>
        <div class="barcode-row">
            <div class="bold">Last trade date:</div>
            29.01.2022 08:12
        </div>
        <div class="barcode-row">
            <div class="bold">Transaction ID:</div>
            market-3846
        </div>
        <div class="barcode-row">
            <div class="bold">Client ID:</div>
            4901
        </div>
    </div>
</template>

<script>
    export default {
        name: "Barcode",
        head: {
            title: 'Barcode information | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'barcode-page'
            }
        }
    }
</script>

<style scoped>
    .barcode-container {
        padding: 50px 15px;
        font-size: 16px;
    }

    h2 {
        margin-top: 20px;
        margin-bottom: 10px;
    }

    .bold {
        display: inline-block;
        margin-right: 5px;
        font-weight: bold;
    }

    .footer-copyright {
        position: fixed;
        bottom: 0;
    }
</style>
<style>
    .barcode-page .logo {
        padding-right: 0;
    }

    .v-navigation-drawer--is-mobile {
        z-index: 106;
    }
</style>
